import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logPageView } from '../services/analytics';

/**
 * Hook to automatically track page views on route changes
 */
export const usePageTracking = () => {
    const location = useLocation();

    useEffect(() => {
        // Log the page view when the location changes
        // We delay slightly to allow document.title to update if handled by other components
        const timeoutId = setTimeout(() => {
            logPageView(location.pathname + location.search);
        }, 100);

        return () => clearTimeout(timeoutId);
    }, [location]);
};
